class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', {bubbles: true});

		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this)),
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define('quantity-input', QuantityInput);

class CartRemoveButton extends HTMLElement {
	constructor() {
	  super();
	  this.addEventListener('click', (event) => {
		event.preventDefault();
		const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
		cartItems.updateQuantity(this.dataset.index, 0);
	  });
	}
  }
  
  customElements.define('cart-remove-button', CartRemoveButton);

/*
 * Shopify Common JS
 *
 */

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	};
}

if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (let i = 0, count = selector.options.length; i < count; i++) {
		let option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	let method = options['method'] || 'post';
	let params = options['parameters'] || {};

	let form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (let key in params) {
		let hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options,
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options['hideElement'] || province_domid,
	);

	Shopify.addListener(
		this.countryEl,
		'change',
		Shopify.bind(this.countryHandler, this),
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		let value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		let value = this.provinceEl.getAttribute('data-default');
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		let opt = this.countryEl.options[this.countryEl.selectedIndex];
		let raw = opt.getAttribute('data-provinces');
		let provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none';
		} else {
			for (let i = 0; i < provinces.length; i++) {
				opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = '';
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (let i = 0; i < values.length; i++) {
			let opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector('[type="button"]');

		if (!button) return;
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'));
			if (modal) modal.show(button);
		});
	}
}
customElements.define('modal-opener', ModalOpener);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, '', false);
		this.removeErrorMessage();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	// Mirrors snippets/product/product-variant-sellable.liquid — any change there must be repercuted here.
	isVariantSellable(variant) {
		if (!variant) return false;

		const threshold = Number(this.dataset.stockThreshold) || 0;
		if (threshold > 0 && variant.inventory_management === 'shopify') {
			const inventoryQty = Number(this.getStockData()[variant.id]) || 0;
			if (inventoryQty <= threshold) return false;
		}

		return Boolean(variant.available);
	}

	getStockData() {
		if (this.stockData) return this.stockData;
		const script = this.querySelector('[data-variant-stock]');
		this.stockData = script ? JSON.parse(script.textContent) : {};
		return this.stockData;
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll('select'),
			(select) => select.value,
		);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateMedia() {
		if (!this.currentVariant) return;
		if (!this.currentVariant.featured_media) return;

		const mediaGallery = document.getElementById(
			`MediaGallery-${this.dataset.section}`,
		);
		mediaGallery.setActiveMedia(
			`${this.dataset.section}-${this.currentVariant.featured_media.id}`,
			true,
		);

		const modalContent = document.querySelector(
			`#ProductModal-${this.dataset.section} .product-media-modal__content`,
		);
		if (!modalContent) return;
		const newMediaModal = modalContent.querySelector(
			`[data-media-id="${this.currentVariant.featured_media.id}"]`,
		);
		modalContent.prepend(newMediaModal);
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState(
			{},
			'',
			`${this.dataset.url}?variant=${this.currentVariant.id}`,
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', {bubbles: true}));
		});
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
		)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				const destination = document.getElementById(
					`price-${this.dataset.section}`,
				);
				const source = html.getElementById(
					`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
				);
				this.updateSourceFromDestination(html, 'price');

				if (source && destination) {
					destination.innerHTML = source.innerHTML;
					const priceSticky = document.getElementById(`price-sticky-${this.dataset.section}`);
					if (priceSticky) priceSticky.innerHTML = source.querySelector('div').innerHTML;
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove('visibility-hidden');
				this.toggleAddButton(
					window.variantStrings.soldOut,
					!this.isVariantSellable(this.currentVariant),
				);

				// Update the variant SKU
				const variantSku = document.querySelector('[data-variant-sku]');
				if (variantSku) variantSku.textContent = this.currentVariant.sku;
			});
	}

	updateSourceFromDestination(html, id, shouldHide = (source) => false) {
		const source = html.getElementById(`${id}-${this.sectionId}`);
		const destination = this.querySelector(`#${id}-${this.dataset.section}`);
		if (source && destination) {
			destination.innerHTML = source.innerHTML;
			destination.classList.toggle('hidden', shouldHide(source));
		}
	}

	toggleAddButton(text, disable = true, modifyClass = true) {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}`,
		);
		if (!productForms.length) return;

		productForms.forEach((productForm) => {
			const addButton = productForm.querySelector('[name="add"]');
			const addButtonText = productForm.querySelector('[name="add"] > span');
			if (!addButton) return;

			if (disable) {
				addButton.setAttribute('disabled', 'disabled');
				if (text && addButtonText) addButtonText.textContent = text;
			} else {
				addButton.removeAttribute('disabled');
				if (addButtonText) {
					addButtonText.textContent = window.variantStrings.addToCart;
				}
			}
		});

		if (!modifyClass) return;
	}

	setUnavailable() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}`,
		);
		const price = document.getElementById(`price-${this.dataset.section}`);

		productForms.forEach((productForm) => {
			const addButton = productForm.querySelector('[name="add"]');
			const addButtonText = productForm.querySelector('[name="add"] > span');
			if (!addButton || !addButtonText) return;
			addButton.setAttribute('disabled', 'disabled');
			addButtonText.textContent = window.variantStrings.unavailable;
		});

		if (price) price.classList.add('visibility-hidden');
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked,
			).value;
		});
	}
}

customElements.define('variant-radios', VariantRadios);
